import { render, staticRenderFns } from "./ModalUsuario.vue?vue&type=template&id=505199c3"
import script from "./ModalUsuario.vue?vue&type=script&lang=js"
export * from "./ModalUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports